import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  Grid,
} from "@chakra-ui/react";
import InventoryClerksTable from "views/Custom/InventoryClerksTable";
import ToolsClerksTable from "views/Custom/ToolsClerksTable";
import MechanicsTable from "views/Custom/MechanicsTable";
import AuditorsTable from "views/Custom/AuditorsTable";

function Personnels() {
  

  return (
    <Flex 
      flexDirection="column" 
      pt={{ base: "120px", md: "75px" }}
      overflow={"auto"}
    >

      <InventoryClerksTable />   

      <ToolsClerksTable />   

      <AuditorsTable />

      <MechanicsTable />

    </Flex>

          

  );
}

export default Personnels;
